import React from "react";
import Button from "./Button";

interface Tab {
  id: number;
  label: string | React.ReactNode;
  value?: string;
  component?: any;
}
interface ButtonTabGroupProps {
  active: Tab;
  setActive: (tab: Tab) => void;
  tabs: Tab[];
}

const Tabs = ({ active, setActive, tabs }: ButtonTabGroupProps) => {
  return (
    <div className="tab-group" role="tablist">
      {tabs.map((tab) => {
        const isActive = active.id === tab.id;
        return (
          <Button
            key={tab.id}
            type="button"
            variant={isActive ? "contained" : "text"}
            className={isActive ? "active" : ""}
            onClick={() => setActive(tab)}
          >
            {tab.label}
          </Button>
        );
      })}
    </div>
  );
};
export default Tabs;
